import $ from 'jquery';

const Cards = function() {
    $(document).ready(function($) {
        $('.wp-block-cmrignite-awareness-card').each(function() {
            var downloadLink = $(this).find('.wp-block-file a').attr('href');
            var heading = $(this).find('h3');
            heading.wrap('<a href="'+ downloadLink +'" target="_blank"></a>');
        });

        $('.card-main').each(function() {
            var downloadLink = $(this).find('.wp-block-file a').attr('href');
            var heading = $(this).find('h3');
            heading.wrap('<a href="'+ downloadLink +'" target="_blank"></a>');
        });
    });

    // Dynamically add the thumbs up/thumbs down to the awareness cards
    $(document).ready(function($) {
        const awarenessCard = document.querySelectorAll('.wp-block-cmrignite-awareness-card');

        // Loop through cards
        awarenessCard.forEach((card) => {

            // Create the new div element
            const thumbs = document.createElement("div");
            // Define markup
            thumbs.innerHTML = "<div class=\"c-was-this-helpful mini-version\">" +
                                 "<p>Was this helpful?</p>" +
                                 "<button class='thumbs-up' aria-label='Thumbs Up'></button>" +
                                 "<button class='thumbs-down' aria-label='Thumbs Down'></button>" +
                                 "</div>";

            // Append to card
            card.querySelector('.wp-block-group__inner-container').appendChild(thumbs);
        });
    });

    // Post filtering
    document.addEventListener('DOMContentLoaded', (event) => {
        document.querySelectorAll('.card-filter').forEach((filter) => {
            filter.addEventListener('click', (e) => {

                // Remove active class
                let siblings = e.target.parentNode.parentNode.children;
                for (let i = 0; i < siblings.length; i++) {
                    siblings[i].children[0].classList.remove('active');
                }

                // Add active class
                e.target.classList.toggle('active');

                // Hide posts
                const filterType = e.target.dataset.filter;

                // Get cards
                const cards = document.querySelectorAll('.primary-card');

                // Hidden array
                let visible = 0;

                // Loop through cards
                cards.forEach((post) => {
                    if (post.dataset.filter !== filterType) {
                        post.style.display = 'none';
                    } else {
                        post.style.display = 'block';
                        visible = visible + 1;
                    }
                });

                // Hide/Unhide empty
                if (visible === 0) {
                    document.querySelector('.card-grid__no-result').style.display = 'block';
                } else {
                    document.querySelector('.card-grid__no-result').style.display = 'none';
                }
            });
        });
    });

    document.addEventListener('DOMContentLoaded', (event) => {
        document.querySelectorAll('.wp-block-file .wp-block-file__button').forEach((downloadButton) => {
            downloadButton.addEventListener('click', (event) => {
                event.preventDefault();
                window.open(event.target.href);
            });
        });
    });
}
export default Cards;